import { FC, useEffect, useState } from 'react'
import _debug from 'debug'
import { useLDClient } from 'launchdarkly-react-client-sdk'
import { Root } from '../../models3/Root'
import { observer } from 'mobx-react'
import { version } from '../../versionNumber' 
import { getCurrentAppClient } from '../utils/Auth0Utils'
import { tinyHash } from '../utils/tinyHash'

const log = _debug('sltt:LDContextChangeListener')

const getIpInfo = async () => {
    const request = await fetch(`https://ipinfo.io/json?token=${import.meta.env.VITE_IPINFO_TOKEN}`)
    return await request.json()
}

interface ILDContextChangeListener {
    rt: Root
}
// this exists to simply watch for context changes and notify ldClient
// (<LDProvider context={getLDContext(rt)} /> has rt undefined during initialization,
// and after initialization, rt may receive sync updates, so when such context updates
// are known then SLTT needs to let LaunchDarkly know about the context changes
// TODO: refactor SLTool to be function component and useLDContext() there instead.
export const LDContextChangeListener: FC<ILDContextChangeListener> = observer(({ rt }) => {
    const [ipinfoData, setIpinfoData] = useState<{ [key: string]: string }>({})
    const ldClient = useLDClient()
    const {
        username, iAmRoot, iAmDeveloper, uiLanguage,
        name: projectName, memberRole, project: { region, projectType },
        isTRLProject
    } = rt

    const locationOrigin = window.location.origin
    useEffect(() => {
        // only needs to happen once
        getIpInfo()
            .then(response => {
                log('ipinfo response', response)
                if (response.ip) {
                    setIpinfoData(response)
                } else {
                    // response has { status, error }
                    console.error('Failed to fetch IP info:', response)
                    setIpinfoData({ ip: 'unknown', city: 'unknown', region: 'unknown', country: 'unknown' })
                }
            })
            .catch(console.error)
    }, [])


    // try to only updateLDContext when something we care about changes
    useEffect(() => {
        if (!ipinfoData.ip) {
            return // wait until we have ip information
        }
        updateLDContext()
    }, [username, iAmRoot, iAmDeveloper, uiLanguage,
        projectName, memberRole, region, projectType, isTRLProject, version, locationOrigin, ipinfoData.ip]
    )

    const updateLDContext = () => {
        const user = {
            kind: 'user',
            key: 'user-' + tinyHash(username),
            email: username,
            iAmRoot,
            iAmDeveloper,
            uiLanguage
        }
        const team = {
            kind: 'team',
            key: 'team-' + projectName,
            projectName: projectName,
            role: memberRole,
            region,
            projectType,
            isTRLProject
        }
        const app = {
            kind: 'app',
            key: getCurrentAppClient(),
            version,
            majorVersion: version.split('.')[0],
            minorVersion: version.split('.')[1],
            locationOrigin,
        }
        const ipinfo = {
            kind: 'ipinfo',
            key: 'ip-' + ipinfoData.ip,
            ...ipinfoData
        }
        const multiContext = {
            kind: 'multi',
            user,
            team,
            app,
            ipinfo,
        }
        log('updateLDContext', multiContext)
        ldClient?.identify(multiContext).catch((error) => console.error(error))
    }
    // console.log('render LDContextChangeListener', {
    //     username, iAmRoot, iAmDeveloper, uiLanguage,
    //     projectName, memberRole, region, projectType, isTRLProject
    // })

    return (<div className="ld-context-watcher"></div>)
})

